// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { Icon } from '@lmc/ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { Icon as OldIcon } from '../../../generic'

/**
@description Renders section header for Team Member Edit Form.

@param {string} antdIcon. Name of antdIcon. If provided, an Antd
icon will be used. If not, a regular Icon is used instead.

@param {string} icon. Name of icon.

@param {string} iconBackground. Background colour for icon.

@param {string} sectionTitle. Section Title.

@returns {function} TeamMemberEditFormSectionHeader.
*/

export default function TeamMemberEditFormSectionHeader(props) {
  const { antdIcon, icon, iconBackground, sectionTitle } = props

  return (
    <div style={styles.sectionHeaderContainer}>
      <div
        style={{
          ...styles.iconContainer,
          background: iconBackground
        }}
      >
        {antdIcon ? (
          <Icon name={antdIcon} style={styles.antdIcon} />
        ) : (
          <OldIcon name={icon} />
        )}
      </div>
      <div style={styles.sectionHeader}>{sectionTitle}</div>
    </div>
  )
}

TeamMemberEditFormSectionHeader.propTypes = {
  antdIcon: PropTypes.string,
  icon: PropTypes.string,
  iconBackground: PropTypes.string.isRequired,
  sectionTitle: PropTypes.string.isRequired
}

const styles = {
  antdIcon: {
    color: colors.white,
    fontSize: 22
  },
  iconContainer: {
    alignItems: 'center',
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: 1,
    height: 40,
    width: 40
  },
  sectionHeader: {
    alignSelf: 'flex-end',
    borderColor: colors.grey,
    fontSize: 24,
    flex: 1,
    marginLeft: 12
  },
  sectionHeaderContainer: {
    display: 'flex',
    marginBottom: 20
  },
  sectionContainer: {
    background: colors.parchment,
    marginTop: 60,
    paddingBottom: 25
  }
}
